export const NEW_ANSWER_REQUEST = 'NEW_ANSWER_REQUEST';
export const NEW_ANSWER_SUCCESS = 'NEW_ANSWER_SUCCESS';
export const NEW_ANSWER_FAIL = 'NEW_ANSWER_FAIL';

export const ANSWER_RESPONSE_REQUEST = 'ANSWER_RESPONSE_REQUEST';
export const ANSWER_RESPONSE_SUCCESS = 'ANSWER_RESPONSE_SUCCESS';
export const ANSWER_RESPONSE_FAIL = 'ANSWER_RESPONSE_FAIL';

export const ANSWER_LIST_REQUEST = 'ANSWER_LIST_REQUEST';
export const ANSWER_LIST_SUCCESS = 'ANSWER_LIST_SUCCESS';
export const ANSWER_LIST_FAIL = 'ANSWER_LIST_FAIL';

export const ANSWER_CONTINUE_REQUEST = 'ANSWER_CONTINUE_REQUEST';
export const ANSWER_CONTINUE_SUCCESS = 'ANSWER_CONTINUE_SUCCESS';
export const ANSWER_CONTINUE_FAIL = 'ANSWER_CONTINUE_FAIL';

export const ANSWER_SAVE_REQUEST = 'ANSWER_SAVE_REQUEST';
export const ANSWER_SAVE_SUCCESS = 'ANSWER_SAVE_SUCCESS';
export const ANSWER_SAVE_FAIL = 'ANSWER_SAVE_FAIL';

export const ANSWER_RESET_REQUEST = 'ANSWER_RESET_REQUEST';
export const ANSWER_RESET_SUCCESS = 'ANSWER_RESET_SUCCESS';
export const ANSWER_RESET_FAIL = 'ANSWER_RESET_FAIL';

export const ANSWER_ADMIN_LIST_REQUEST = 'ANSWER_ADMIN_LIST_REQUEST';
export const ANSWER_ADMIN_LIST_SUCCESS = 'ANSWER_ADMIN_LIST_SUCCESS';
export const ANSWER_ADMIN_LIST_FAIL = 'ANSWER_ADMIN_LIST_FAIL';

export const ANSWER_ADMIN_LOAD_REQUEST = 'ANSWER_ADMIN_LOAD_REQUEST';
export const ANSWER_ADMIN_LOAD_SUCCESS = 'ANSWER_ADMIN_LOAD_SUCCESS';
export const ANSWER_ADMIN_LOAD_FAIL = 'ANSWER_ADMIN_LOAD_FAIL';
